import { render, staticRenderFns } from "./my-project.vue?vue&type=template&id=ea0a7092&scoped=true&"
import script from "./my-project.vue?vue&type=script&lang=js&"
export * from "./my-project.vue?vue&type=script&lang=js&"
import style0 from "./my-project.vue?vue&type=style&index=0&id=ea0a7092&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0a7092",
  null
  
)

export default component.exports